var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStepActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_28",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 15C18.15 15 17.4375 14.7125 16.8625 14.1375C16.2875 13.5625 16 12.85 16 12C16 11.15 16.2875 10.4375 16.8625 9.86249C17.4375 9.28749 18.15 8.99999 19 8.99999C19.85 8.99999 20.5625 9.28749 21.1375 9.86249C21.7125 10.4375 22 11.15 22 12C22 12.85 21.7125 13.5625 21.1375 14.1375C20.5625 14.7125 19.85 15 19 15ZM10.175 13H3C2.71667 13 2.47917 12.9042 2.2875 12.7125C2.09583 12.5208 2 12.2833 2 12C2 11.7167 2.09583 11.4792 2.2875 11.2875C2.47917 11.0958 2.71667 11 3 11H10.175L8.3 9.09999C8.11667 8.91665 8.02083 8.68749 8.0125 8.41249C8.00417 8.13749 8.1 7.89999 8.3 7.69999C8.48333 7.51665 8.71667 7.42499 9 7.42499C9.28333 7.42499 9.51667 7.51665 9.7 7.69999L13.3 11.3C13.5 11.5 13.6 11.7333 13.6 12C13.6 12.2667 13.5 12.5 13.3 12.7L9.7 16.3C9.5 16.5 9.26667 16.5958 9 16.5875C8.73333 16.5792 8.5 16.475 8.3 16.275C8.11667 16.075 8.02083 15.8417 8.0125 15.575C8.00417 15.3083 8.1 15.075 8.3 14.875L10.175 13Z",
    fill: "#4BD7D1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStepActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/step-active.d0b4398691b804d685ddca3a1491e9de.svg";